import backicon from "../../../assets/images/backicon.svg";
import styled from "styled-components";
import { Tooltip, Spin, Upload } from "antd";
import { Switch, Row, Col, message, Select } from "antd";
import reset from "../../../assets/images/reset-svgrepo-com.svg";
import deleteicon from "../../../assets/images/delete-3-svgrepo-com.svg";
import edit from "../../../assets/images/edit-1-svgrepo-com.svg";
import { useLocation } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import { Tabs } from "antd";
import {
  EyeOutlined,
  DownloadOutlined,
  DeleteOutlined,
  DownOutlined,
} from "@ant-design/icons";
import UIModal from "../../../Reusablecomponents/UIModal";
import { useNavigate } from "react-router-dom";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import { CALL_API } from "../../../Common/api";
import { useSelector } from "react-redux";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import { EventType } from "../../../Common/constant";
import moment from "moment";
import FilesTable from "../../../Reusablecomponents/FilesTable";

const Customstyle = styled.div`
  padding: 15px;
  /* .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
  } */
  /* .head1,
  .status {
    display: flex;
    align-items: center;
    gap: 10px;
  } */
  /* .status {
    margin-right: 40px;
  } */
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .head1 {
    display: flex;
    gap: 20px;
    width: 60%;
    align-items: center;
  }
  .status {
    display: flex;
    width: 40%;
    gap: 20px;
    justify-content: flex-end;
    align-items: center;
  }
  @media (max-width: 480px) {
    .status {
      width: 100%;
    }
    .head1 {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
    gap: 15px;
    justify-content: flex-start;
  }

  .title1 {
    font-weight: 500;
    font-size: 16px;
    margin-top: 15px;
  }
  .icons {
    display: flex;
    gap: 30px;
  }
  .icons_one {
    padding: 9px;
    background-color: lightgray;
    border-radius: 50%;
  }
  .icons_one:hover {
    background-color: white;
  }

  .title {
    font-weight: 500;
    font-size: 16px;
    margin-top: 10px;
  }
  .ant-switch-checked {
    background-color: #31ab46 !important; /* Green color */
  }
  .company {
    font-size: 14px;
    font-weight: 400;
    color: #5f6d8c;
  }
  .data {
    font-weight: 400;
    font-size: 16px;
  }
  .ant-tabs-tab {
    font-size: 18px !important;
    font-weight: 500 !important;
    color: #5f6d8c !important;
    border-radius: 27px !important;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #2c963d !important;
  }
  .ant-tabs-tab:hover {
    color: #5f6d8c !important; /* Darker green on hover */
  }
  .tabstyle {
    display: flex;
    justify-content: space-between;
    border-radius: 27px !important;
  }
  .backicon {
    margin-bottom: 5px;
  }
  @media (max-width: 480px) {
    .status_menu_customization {
      width: auto;
      display: flex;
      flex-direction: row;
    }
    .status_menu_two {
      display: flex;
      flex-direction: column;
      gap: 15px;
      align-items: flex-end;
    }
    .head {
      align-items: flex-start;
      flex-direction: column;
    }
    .ant-tabs-nav-list {
      flex-wrap: wrap;
    }
  }
`;
const CustomSelect = styled(Select)`
  width: 100%;
  height: 54px;
  border-radius: 10px !important;

  .ant-select-selector {
    border-radius: 15px !important;
    border: none !important;
    padding: 8px !important;
    background-color: rgb(230, 231, 231) !important;
  }

  /* Custom placeholder color */
  .ant-select-selection-placeholder {
    color: #363636 !important; /* Change placeholder color */
    font-weight: 400;
    font-size: 16px;
  }
  .ant-select-arrow {
    color: #5f6d8c !important;
    padding-right: 10px;
  }
`;

const ResetUser = ({
  fetchUserLiat,
  record,
  setIsView,
  setFormData,
  setIsEdit,
  handleDelete,
  handleReset,
  setOpen,
  dloading,
}) => {
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const roleList = useSelector((state) => state?.authTracking?.roleList);
  const officeList = useSelector((state) => state?.authTracking?.officeList);
  const [activekey, setactivekey] = useState("1");
  const [company, setCompany] = useState(record);
  const [loading, setLoading] = useState(false);
  const [sessionLogList, setSessionLogList] = useState([]);
  const [actionLogList, setActionLogList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filesList, setFilesList] = useState([]);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null); // To store the ID of the consignment to delete
  const [CustomData, setCustomData] = useState([]);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const updateAllowed = useMemo(
    () => hasPermission("USR", "U"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("USR", "D"),
    [reduxPermissions],
  );
  const getcustomedatabyRefId = async () => {
    try {
      // const { data } = await CALL_API(
      //   "GET",
      //   `mastertable/GetCustomeData?RefId=${fuelId}`
      // );
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "USER",
        RefId: record?.UID,
        Active: 1,
        McId: userInfo?.MCID,
      });

      if (Array.isArray(data)) {
        setCustomData(data);
      } else if (typeof data === "object" && data !== null) {
        // Wrap the single object in an array
        setCustomData([data]);
      } else {
        setCustomData([]);
        console.warn("Unexpected custom data format:", data);
      }
    } catch (error) {
      console.error("Error fetching custom data:", error);
      setCustomData([]);
    }
  };
  const fetchLoctionList = async (isreset) => {
    setLoading(isreset ? false : true);
    const { data } = await CALL_API(
      "GET",
      `user/getLocationList?UID=${company?.UID}&limit=${pageSize}&page=${currentPage}`,
    );
    setLocationList(data?.data || []);
    setTotal(data?.totalRecords || 0);
    setLoading(false);
  };

  const fetchActionList = async (isreset) => {
    setLoading(isreset ? false : true);
    const { data } = await CALL_API(
      "GET",
      `user/getActionLogs?UID=${company?.UID}&limit=${pageSize}&page=${currentPage}`,
    );
    setActionLogList(data?.data || []);
    setTotal(data?.totalRecords || 0);
    setLoading(false);
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const fetchSessionLogLiat = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "GET",
      `user/getSessionLogs?UID=${company?.UID}&limit=${pageSize}&page=${currentPage}`,
    );
    setSessionLogList(data?.data || []);
    setTotal(data?.totalRecords || 0);
    setLoading(false);
  };
  const getFileData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trip/getFileTab`, {
      refTab: "USERS",
      refId: record?.UID,
    });
    setFilesList(data);
    setLoading(false);
  };

  useEffect(() => {
    if (activekey === "1") {
      getFileData();
      getcustomedatabyRefId();
    } else if (activekey === "2") {
      fetchSessionLogLiat();
    } else if (activekey === "3") {
      fetchActionList();
    } else {
      fetchLoctionList();
    }
  }, [activekey, currentPage, pageSize]);

  const toogleUser = async (checked) => {
    try {
      setLoading(true);

      await CALL_API("POST", `user/lock`, {
        userId: company?.UID,
        lock: !checked, // if ON (checked=true) → lock=false (active)
      });

      // Refresh list or specific user
      fetchUserLiat();
      setIsView(false);
      message.success("User Status Updated Successfully");
    } catch (error) {
      console.error("Error toggling user:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = async (payload) => {
    setLoading(true);
    const { data } = await CALL_API("POST", "common/file/addFile", payload);
    setLoading(false);
    getFileData();
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "Title",
      key: "Title",
    },
    {
      title: "File Size",
      dataIndex: "FileSize",
      key: "FileSize",
    },
    {
      title: "File Type",
      dataIndex: "FileType",
      key: "FileType",
    },
    {
      title: "Added by",
      dataIndex: "Addedby",
      key: "Addedby",
    },

    {
      title: "",
      width: 150,
      key: "actions",
      render: (_, record) => (
        <div>
          <EyeOutlined
            style={{ color: "#5F6D8C", fontSize: "18px", marginRight: "18px" }}
          />
          <DownloadOutlined
            style={{ color: "#00BC13", fontSize: "18px", marginRight: "18px" }}
          />
          <DeleteOutlined
            style={{ color: "#F20000", fontSize: "18px", marginRight: "18px" }}
          />
        </div>
      ),
    },
  ];

  const columns1 = [
    {
      title: "Login",
      dataIndex: "SLOGIN",
      key: "SLOGIN",
    },
    {
      title: "Last Access",
      dataIndex: "LASTACCESS",
      key: "LASTACCESS",
    },
    {
      title: "Source",
      dataIndex: "SOURCE",
      key: "SOURCE",
    },
    {
      title: "IP Address",
      dataIndex: "IPADDR",
      key: "IPADDR",
    },
    {
      title: "Information",
      dataIndex: "SOURCEINFO",
      key: "SOURCEINFO",
    },
    {
      title: "Duration (Mins)",
      dataIndex: "DUR",
      key: "DUR",
    },
  ];

  const columns2 = [
    {
      title: "Action Time",
      dataIndex: "ACTTIME",
      key: "ACTTIME",
    },
    {
      title: "Action by",
      dataIndex: "ACTIONBY",
      key: "ACTIONBY",
    },
    {
      title: "Source",
      dataIndex: "SRC",
      key: "SRC",
    },
    {
      title: "Action",
      dataIndex: "ACTION",
      key: "ACTION",
    },
    {
      title: "Information",
      dataIndex: "INFO",
      key: "INFO",
    },
  ];

  const columns3 = [
    {
      title: "Event",
      dataIndex: "EVTYPE",
      key: "EVTYPE",
      render: (text) => {
        return EventType?.find((item) => item?.value === text)?.name || "-";
      },
    },
    {
      title: "Updated on",
      dataIndex: "CREATED",
      key: "CREATED",
      render: (text) => {
        return moment(text).format("Do MMM YYYY; hh:mm A");
      },
    },
    {
      title: "Updated by",
      dataIndex: "UserName",
      key: "UserName",
    },
    {
      title: "Location",
      dataIndex: "Lat",
      key: "Lat",
      render: (text, record) => {
        return `${record?.Lat}, ${record?.Lng}`;
      },
    },
    {
      title: "Consignment",
      dataIndex: "ConsignId",
      key: "ConsignId",
    },
  ];

  return (
    <>
      <Customstyle>
        <div className="head">
          <div className="head1">
            <div className="backicon">
              <img
                src={backicon}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setIsView(false);
                }}
              />
            </div>
            <div className="title">
              <p>
                User Details - {company?.FIRSTNM} {company?.LASTNM}
              </p>
            </div>
          </div>

          <div className="status ">
            <div className="title1 ">
              <p>Status </p>
            </div>
            <div>
              <Switch
                checked={company?.LOCKED === false} // ON when Active
                loading={loading}
                onChange={(checked) => toogleUser(checked)}
              />
            </div>
            <Customstyle>
              <div className="icons">
                <div className="icons_one">
                  <Tooltip title={"Reset"}>
                    <img
                      src={reset}
                      onClick={() => handleReset(company)}
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                </div>
                <div className="icons_one">
                  <Tooltip title={!updateAllowed ? "No permission" : "Edit"}>
                    <img
                      src={edit}
                      style={{
                        cursor: updateAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!updateAllowed) return;
                        setFormData({
                          UID: record?.UID,
                          userid: record?.USERID,
                          firstname: record?.FIRSTNM,
                          lastname: record?.LASTNM,
                          email: record?.EMAIL,
                          PWHASH: record?.PWHASH,
                          ZONE: record?.ZONE,
                          MNGID: record?.MNGID,
                          LOCKED: record?.LOCKED,
                          SYSADM: record?.UID === 2 ? 1 : 0,
                          CRBY: record?.CRBY,
                          office: record?.OFFID,
                          CHATCONID: record?.CHATCONID,
                          phone: record?.CONTACTNO, // Assuming CONTACTNO is used for phone
                          DASHWIDGETS: record?.DASHWIDGETS,
                          role: record?.ROLEID,
                        });
                        setIsEdit(true);
                        setOpen(true);
                      }}
                    />
                  </Tooltip>
                </div>
                <div className="icons_one">
                  <Tooltip title={!deleteAllowed ? "No permission" : "Delete"}>
                    <img
                      src={deleteicon}
                      style={{
                        cursor: deleteAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!deleteAllowed) return;
                        setIsDeleteModalVisible(true);
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            </Customstyle>
          </div>
        </div>
        <UIModal
          width={500}
          open={isDeleteModalVisible}
          onClose={() => {
            setIsDeleteModalVisible(false);
            setDeleteId(null); // Reset the delete ID
          }}
          closeButton={false}
          size="md"
          header={false}
          footer={false}
        >
          <div className="text-center">
            <h1>Are you sure,</h1>
            <h6>You want to delete this User?</h6>
            <div className="mt-2 w-100 d-flex justify-content-center">
              <ButtonFilled
                loading={dloading}
                disabled={!deleteAllowed}
                onClick={() => {
                  handleDelete(company); // Pass the full user object
                  setIsDeleteModalVisible(false); // Reset the delete ID
                }}
              >
                Yes
              </ButtonFilled>
              <Buttontransparent
                onClick={() => {
                  setIsDeleteModalVisible(false); // Close the modal
                  setDeleteId(null); // Reset the delete ID
                }}
              >
                No
              </Buttontransparent>
            </div>
          </div>
        </UIModal>
        <div style={{ padding: "20px" }}>
          <Row gutter={[24, 24]}>
            <Col sm={12} md={6}>
              <p className="company">User ID</p>
              <p> {company?.USERID || "---"}</p>
            </Col>
            <Col sm={12} md={6}>
              {" "}
              <p className="company">First Name</p>
              <p className="data"> {company?.FIRSTNM || "---"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Last Name</p>
              <p className="data"> {company?.LASTNM || "---"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Email</p>
              <p className="data"> {company?.EMAIL || "---"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Office </p>
              <p className="data">
                {officeList?.find((val) => val?.OFFID === company?.OFFID)
                  ?.OFFNM || "---"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Phone</p>
              <p className="data"> {company?.CONTACTNO || "---"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Role</p>
              <p className="data">
                {roleList?.find((item) => item?.ROLEID === company?.ROLEID)
                  ?.ROLENAME || "---"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              {Array.isArray(CustomData) &&
                CustomData.length > 0 &&
                CustomData.map((field) => (
                  <div className="consignor_code" key={field.CFID}>
                    <label>{field.FIELDNAME}</label>
                    <p>{field.VALUE || "-"}</p>
                  </div>
                ))}
            </Col>
          </Row>
          <br />
          <br />

          <div className="tabstyle">
            <div>
              <Tabs
                onChange={(key) => setactivekey(key)}
                type="card"
                items={[
                  {
                    label: "Files",
                    key: "1",
                  },
                  {
                    label: "Session Log",
                    key: "2",
                  },
                  {
                    label: "Action Log",
                    key: "3",
                  },
                  {
                    label: "Location",
                    key: "4",
                  },
                ]}
              />
            </div>

            <div>
              {activekey === "1" && (
                <div>
                  <Upload
                    customRequest={({ file, onSuccess }) => {
                      // Get current position
                      navigator.geolocation.getCurrentPosition(
                        (position) => {
                          const { latitude, longitude } = position.coords;
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            const base64Data = reader.result.split(",")[1];
                            onSuccess();

                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "USERS",
                              refId: record?.UID,
                              lat: String(latitude),
                              lng: String(longitude),
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                              BASE: base64Data,
                            };
                            handleFileUpload(payload);
                          };

                          reader.onerror = (error) => {
                            console.error("File read error:", error);
                          };
                        },
                        (error) => {
                          // If location access denied or failed, fallback to empty values
                          console.error("Geolocation error:", error);
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            onSuccess();
                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "USERS",
                              refId: record?.UID,
                              lat: "",
                              lng: "",
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };
                        },
                      );
                    }}
                    showUploadList={false}
                  >
                    <ButtonFilled className="upload-style1">+ Add</ButtonFilled>
                  </Upload>
                </div>
              )}
            </div>
          </div>
          {activekey === "1" && (
            <div>
              <Spin spinning={loading}>
                <FilesTable filesList={filesList} getFileData={getFileData} />
              </Spin>
            </div>
          )}
          {activekey === "2" && (
            <div>
              <Spin spinning={loading}>
                <StyledTable
                  dataSource={sessionLogList}
                  columns={columns1}
                  pagination={false}
                />
                <ReusablePagination
                  pageSize={pageSize} // Current page size
                  handlePageSizeChange={handlePageSizeChange} // Function to handle page size change
                  currentPage={currentPage} // Current page number
                  total={total} // Total number of records
                  handlePageChange={handlePageChange} // Function to handle page change
                />
              </Spin>
            </div>
          )}
          {activekey === "3" && (
            <div>
              <Spin spinning={loading}>
                <StyledTable
                  dataSource={actionLogList}
                  columns={columns2}
                  pagination={false}
                />
                <ReusablePagination
                  pageSize={pageSize} // Current page size
                  handlePageSizeChange={handlePageSizeChange} // Function to handle page size change
                  currentPage={currentPage} // Current page number
                  total={total} // Total number of records
                  handlePageChange={handlePageChange} // Function to handle page change
                />
              </Spin>
            </div>
          )}
          {activekey === "4" && (
            <div>
              <Spin spinning={loading}>
                <StyledTable
                  dataSource={locationList}
                  columns={columns3}
                  pagination={false}
                />
                <ReusablePagination
                  pageSize={pageSize}
                  handlePageSizeChange={handlePageSizeChange}
                  currentPage={currentPage}
                  total={total}
                  handlePageChange={handlePageChange}
                />
              </Spin>
            </div>
          )}
        </div>
      </Customstyle>
    </>
  );
};

export default ResetUser;
